import { luckyWheelConstant } from '../constant';
export const luckyWheelAction = {
    getLuckyWheelDetails,
    setLuckyWheelisEnabled,
};

function getLuckyWheelDetails(data) {
    return (dispatch) => {
        dispatch({ 
            type: luckyWheelConstant.GET_LUCKY_WHEEL_DETAILS, 
            payload: data 
        });
    };
}

function setLuckyWheelisEnabled(data) {
    return (dispatch) => {
        dispatch({ 
            type: luckyWheelConstant.SET_LUCKY_WHEEL_IS_ENABLED, 
            payload: data 
        });
    };
}